import ChangePassword from "../../components/company/change-password";

const ChangePasswordPage: React.FC = () => {
    return <ChangePassword/>
}

export default ChangePasswordPage;